export const ACTION_GET_LATEST_REVIEW = '/ProductReviews/GetLatestReview';